import { render, staticRenderFns } from "./categoria.update.vue?vue&type=template&id=5797c50a&scoped=true&"
import script from "./categoria.update.vue?vue&type=script&lang=js&"
export * from "./categoria.update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5797c50a",
  null
  
)

export default component.exports